import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Lock, Crown } from "lucide-react";
import { PREMIUM } from "@/constants/testIds/premium";

export const PremiumLimitModal = ({ open, onOpenChange, message }) => {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={PREMIUM.limitModal}
        className="border-slate-700 bg-slate-900 text-white sm:max-w-md"
      >
        <DialogTitle className="sr-only">Limite diário atingido</DialogTitle>
        <div className="flex flex-col items-center gap-4 py-4 text-center">
          <div className="grid h-16 w-16 place-items-center rounded-full bg-amber-400/15 text-amber-300">
            <Lock className="h-8 w-8" />
          </div>
          <div>
            <h3 className="text-xl font-extrabold">Limite diário atingido</h3>
            <p className="mt-2 text-sm text-slate-400">
              {message || "Você usou suas 10 questões grátis de hoje. Assine o Premium para questões ilimitadas."}
            </p>
          </div>
          <div className="w-full rounded-xl border border-amber-400/30 bg-amber-400/5 p-4 text-left">
            <p className="text-sm font-bold text-amber-300">Premium — R$ 19,90/mês</p>
            <p className="text-xs text-emerald-400">7 dias grátis · questões e simulados ilimitados</p>
          </div>
          <button
            data-testid={PREMIUM.limitModalCta}
            onClick={() => navigate("/premium")}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 px-5 py-3 text-sm font-bold text-slate-950 transition-transform hover:scale-[1.02] active:scale-95"
          >
            <Crown className="h-4 w-4" /> Quero ser Premium
          </button>
          <button
            onClick={() => onOpenChange(false)}
            className="text-xs font-semibold text-slate-500 hover:text-slate-300"
            data-testid="premium-limit-modal-close"
          >
            Continuar amanhã
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
